import React, { useContext } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { download } from '@mummssoftware/utils/hope';
import { Button } from '@material-ui/core';
import { HopeContext } from '../Context/HopeWidgetContext';
import { SET_BATCH_MODE } from '../Context/constants';
import { StyledButton } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

export const BatchDownloadButton = () => {
  const {
    palette: { primary },
  } = useTheme() as any;
  const {
    dispatch,
    batchMode,
    batchDownloadXML,
    selectedRows,
    showLoader,
  } = useContext(HopeContext);
  const isBatchDownload = batchMode === download;

  const showButton = !batchMode || isBatchDownload;
  const enabled = showLoader
    ? false
    : !isBatchDownload || !!selectedRows?.length;

  // styles defined here to override MUI css
  return (
    <>
      {showButton && (
        <StyledButton
          style={{
            color: primary.contrastText,
            backgroundColor: enabled ? primary.main : 'grey',
            fontSize: '10px',
            height: '1.25em',
            fontWeight: 'bold',
            padding: '10px',
            margin: '5px',
          }}
          onClick={() => {
            if (isBatchDownload) {
              selectedRows &&
                selectedRows?.length > 0 &&
                batchDownloadXML(selectedRows);
            } else {
              dispatch({ type: SET_BATCH_MODE, payload: download });
            }
          }}
        >
          {batchMode ? 'Download' : `${defaults.batchDownload}`}
        </StyledButton>
      )}
    </>
  );
};
